module.exports = __webpack_public_path__ + "img/ueber-mich-2_640.72e0c8b0.jpg";